import { LitElement, css } from "lit-element";
import { html } from "lit-html";
import PubSub from "pubsub-js";
import "@ui5/webcomponents/dist/Button.js";
import "@ui5/webcomponents/dist/Dialog.js";
import "@ui5/webcomponents/dist/Panel.js";
import "./helpset/kb-topic-experimental";
import "@ui5/webcomponents/dist/Button.js";

/**
 * Topic not found in ditamap
 * @property {Boolean} dialogOpened - controls whether dialog is mounted to DOM
 */
export class KbDialogTopic extends LitElement {
  static properties = {
    dialogOpened: { state: true, type: Boolean },
    metadata: { type: Object },
  };

  constructor() {
    super();
    this.dialogOpened = false;
  }

  connectedCallback() {
    super.connectedCallback();
    let token = PubSub.subscribe("message.topic", this.getData.bind(this));
    if (!token) console.log("An error occurred");
  }

  getData(msg, data) {
    this.metadata = { href: data };
    this.show();
  }

  show() {
    this.dialogOpened = true;
  }

  hide() {
    this.dialogOpened = false;
    window.history.back();
  }

  render() {
    return html`
      <ui5-dialog header-text="Standalone Topic" ?open=${this.dialogOpened}>
        <kb-topic-experimental
          .metadata=${this.metadata}
        ></kb-topic-experimental>
        <footer>
          <ui5-button theme="primary" @click=${this.hide}>Close</ui5-button>
        </footer>
      </ui5-dialog>
    `;
  }

  static styles = css`
    footer {
      text-align: center;
    }
  `;
}

customElements.define("kb-dialog-topic", KbDialogTopic);
